import { ChangeDetectorRef, Component, ViewChild, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { GenerateEmissionReportComponent } from 'src/app/shared/components/generate-emission-report/generate-emission-report.component';
import { ToastrService } from 'ngx-toastr';
import { ToasterMessages } from 'src/app/shared/constants/constants';
import { getmonths, getShipNameOptions, gettypeofreport, getvesselname } from 'src/app/shared/helpers/dropdown-options';
import { EmissionService } from 'src/app/shared/service/emission-service/emission.service';
import { OverlapService } from 'src/app/shared/service/overlapService/overlap.service';
import { RequestFormService } from 'src/app/shared/service/requestForm/request-form.service';

@Component({
  selector: 'app-eu-ets',
  templateUrl: './eu-ets.component.html',
  styleUrls: ['./eu-ets.component.scss']
})
export class EuEtsComponent implements OnInit {

  @ViewChild(MatSort) sort!: MatSort;

  myreportForm: FormGroup;
  monthOptions: any;
  shipnameoptions: any;
  vesselnameoptions: any;
  typeofreportoptions: string[];

  paginatedData: any[] = [];
  currentPage: number = 0;
  itemsPerPage: number = 100;

  elements: any[] = [];
  vesselNameSuggestions: any[] = [];

  isLoading: boolean = false;
  selectedReport: string = '';
  tableData: any[] = [];
  imo!: number | string;
  vesselName: string = '';
  Number = Number;
  subusername: any;

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private emissionService: EmissionService,
    private router: Router,
    private route: ActivatedRoute,
    private overlayService: OverlapService,
    private requestFormService: RequestFormService,
    private cdr: ChangeDetectorRef,
    private dialog: MatDialog,
  ) {
    this.myreportForm = this.fb.group({
      vesselname: [''],
      typeofreport: [''],
      from_date: [''],
      to_date: [''],
      month: [''],
      vesselIMO: ['', [Validators.pattern('^[0-9]*$')]],
    });

    this.monthOptions = getmonths();
    this.shipnameoptions = getShipNameOptions();
    this.vesselnameoptions = getvesselname();
    this.typeofreportoptions = gettypeofreport();

    this.paginateData();
  }

  ngOnInit(): void {
     this.subusername = localStorage.getItem('loginPic') ?? '';

    this.route.paramMap.subscribe(params => {
      this.imo = params.get('imo') || '';
      if (this.imo) {
        this.fetchReportTableData();
      } else {
        this.toastr.error('No IMO provided in URL');
      }
    });
  }

  ngAfterViewInit() {
    if (this.sort) {
      this.sort.sortChange.subscribe((sort: Sort) => {
        this.sortData(sort);
      });
    }
  }

  fetchReportTableData() {
    this.isLoading = true;

    this.emissionService.getETSVoyages(this.imo).subscribe(
      (res: any) => {
        this.isLoading = false;

        this.tableData = res?.voyages || [];
       
        this.elements = [...this.tableData];
        this.currentPage = 0;
        this.paginateData();
        if(this.subusername === 'demo'){
           const originalImo = res?.imo_number
            this.vesselName = originalImo === 9399480 ? 'Vessel 1' : 'Vessel 2';
        }else{
           this.vesselName = res?.voyages[0].vessel_name || '';
        }
        this.cdr.detectChanges();
      },
      () => {
        this.isLoading = false;
        this.toastr.error('EU ETS Voyage data not found');
        this.cdr.detectChanges();
      }
    );
  }

  onReportSelect(selectedType: string, row: any) {
    const payload = {
      report_type: selectedType,
      vessel_imo: row.ship_imo,
      hp_number: row.hp_np,
      voyage_no: row.voyage_no,
    };

    this.emissionService.printFinalReport(payload).subscribe(
      (response: any) => {
        this.overlayService.showPdf(response);
      },
      () => {
        this.toastr.info(ToasterMessages.RecordNotFount);
      }
    );
  }

  sortData(sort: Sort) {
    const data = this.paginatedData.slice();
    if (!sort.active || sort.direction === '') {
      this.paginatedData = data;
      return;
    }

    const isAsc = sort.direction === 'asc';

    this.paginatedData = data.sort((a, b) => {
      const valueA = a[sort.active];
      const valueB = b[sort.active];
      if (valueA == null) return isAsc ? -1 : 1;
      if (valueB == null) return isAsc ? 1 : -1;
      return (valueA < valueB ? -1 : 1) * (isAsc ? 1 : -1);
    });
  }

  paginateData() {
    const startIndex = this.currentPage * this.itemsPerPage;
    this.paginatedData = this.elements.slice(startIndex, startIndex + this.itemsPerPage);
  }

  onPageChange(event: PageEvent) {
    this.currentPage = event.pageIndex;
    this.itemsPerPage = event.pageSize;
    this.paginateData();
  }

  filterClick() {
    const from = this.myreportForm.get('from_date')?.value ? new Date(this.myreportForm.get('from_date')?.value) : null;
    const to = this.myreportForm.get('to_date')?.value ? new Date(this.myreportForm.get('to_date')?.value) : null;

    const vesselIMO = this.myreportForm.get('vesselIMO')?.value?.trim() || '';
    const month = this.myreportForm.get('month')?.value || '';
    const vesselName = this.myreportForm.get('vesselname')?.value?.trim() || '';
    const reportType = this.myreportForm.get('typeofreport')?.value?.trim() || '';

    const filtered = this.tableData.filter((row) => {
      const rowDate = row.ingested_time ? new Date(row.ingested_time) : null;

      return (
        (!from || (rowDate && rowDate >= from)) &&
        (!to || (rowDate && rowDate <= to)) &&
        (!month || row.voyage_month === month) &&
        (!vesselIMO || row.ship_imo?.toLowerCase().includes(vesselIMO.toLowerCase())) &&
        (!vesselName || row.ship_name?.toLowerCase().includes(vesselName.toLowerCase())) &&
        (!reportType || row.report_type === reportType)
      );
    });

    this.paginatedData = filtered;
  }

  clearClick() {
    this.myreportForm.reset();
    this.fetchReportTableData();
  }

  goBack() {
    this.router.navigate(['/E-euEts']);
  }

  isDarkMode() {
    return this.requestFormService.isDarkMode();
  }

  refreshPageData() {
    this.isLoading = true;
    this.fetchReportTableData();
  }

  openGenerateReportPopup(row: any) {
    this.dialog.open(GenerateEmissionReportComponent, {
      width: '560px',
      data: { ...row, reportType: 'EUETS' },
      disableClose: true,
    });
  }
}